import { useAppSelector } from "../../../hooks/useRedux";
import { useGetDrFirstNotificationCount } from "./e-prescribe.queries";
import useCanViewEPrescribeFlow from "./useCanViewEPrescribeFlow";

export default function useGetEPrescribeNotificationsCount() {
    const { practice } = useAppSelector((state) => state.userPractice);
    const canViewEPrescribeFlow = useCanViewEPrescribeFlow();
    const practiceId = practice?.practice_id ?? "";
    const { data, isLoading, isError } = useGetDrFirstNotificationCount(
        practiceId,
        canViewEPrescribeFlow && !!practiceId
    );

    if (
        isLoading ||
        isError ||
        !canViewEPrescribeFlow ||
        !practiceId ||
        !data?.data?.notification_counts
    ) {
        return null;
    }

    const therapyMessagesCount =
        (data.data.notification_counts.refill ?? 0) +
        (data.data.notification_counts.rxchange ?? 0);

    const pendingPrescriptions =
        data.data.notification_counts.rx_pending <= 0 ? null : (
            <span className="size-3 rounded-full bg-danger text-white flex items-center justify-center text-[7px] font-bold ml-1">
                {data.data.notification_counts.rx_pending}
            </span>
        );

    const therapyMessages =
        therapyMessagesCount <= 0 ? null : (
            <span className="size-3 rounded-full bg-danger text-white flex items-center justify-center text-[7px] font-bold ml-1">
                {therapyMessagesCount}
            </span>
        );

    return {
        pendingPrescriptions,
        therapyMessages,
    };
}
